import { FormUserMessages, TranslationFormUserMessages } from "@languages/interfaces";

export const messages: TranslationFormUserMessages = {
  [FormUserMessages.fieldEmail]: "Email",
  [FormUserMessages.fieldName]: "Nome",
  [FormUserMessages.fieldPosition]: "Cargo",
  [FormUserMessages.fieldDescription]: "Descrição",
  [FormUserMessages.fieldActive]: "Este usuário está ativo",
  [FormUserMessages.fieldInactive]: "Este usuário está inativo",
  [FormUserMessages.addImage]: "Adicionar foto",
  [FormUserMessages.removeImage]: "Remover foto",
  [FormUserMessages.deletionConfirmationTitleModal]: "Confirmação de exclusão",
  [FormUserMessages.deletionConfirmationSubtitleModal]: "Ao confirmar, o usuário será removido de todas as soluções Topcon. "
      + "Você tem certeza que deseja continuar?"
};